export const Colors = {
  brandOne: "#B0D9FF",
  brandTwo: "#156082",
  brandThree: "#0E7CAF",
  statIcon: "#2563eb"
};
